// Gestione permessi/funzioni per utente (feature overrides impostate dall'Admin).
// Ogni funzione ha una chiave (= path della pagina), i ruoli di default e un'etichetta.
// L'Admin può forzare on/off la funzione per singolo utente tramite user.feature_overrides.

export const FEATURE_GROUPS = [
  {
    title: 'Vendite',
    features: [
      { key: '/leads', label: 'Lead', roles: ['Admin', 'Commerciale', 'Amministrativo', 'CapoGruppo', 'Visitatore'] },
      { key: '/quotes', label: 'Preventivi', roles: ['Admin', 'Commerciale', 'Amministrativo', 'CapoGruppo', 'Visitatore'] },
      { key: '/contratti', label: 'Contratti', roles: ['Admin', 'Commerciale', 'Amministrativo', 'CapoGruppo', 'Visitatore'] },
      { key: '/contratti-annullati', label: 'Contratti Annullati', roles: ['Admin', 'Commerciale', 'Amministrativo', 'CapoGruppo', 'Visitatore'] },
      { key: '/analytics', label: 'Analisi Vendite', roles: ['Admin', 'Commerciale', 'Amministrativo', 'CapoGruppo', 'Visitatore'] },
      { key: '/calcolatore-finanziario', label: 'Calcolatore finanziario', roles: ['Admin', 'Commerciale', 'Amministrativo', 'CapoGruppo'] },
      { key: '/marketing', label: 'Marketing', roles: ['Admin', 'Commerciale', 'Amministrativo', 'CapoGruppo'] },
      { key: '/whatsapp', label: 'WhatsApp', roles: ['Admin', 'Amministrativo', 'Commerciale', 'CapoGruppo'] },
    ],
  },
  {
    title: 'Operazioni',
    features: [
      { key: '/projects', label: 'Cantieri', roles: ['Admin', 'Commerciale', 'Operativo', 'Caposquadra', 'Amministrativo', 'CapoGruppo', 'Visitatore'] },
      { key: '/timbratura', label: 'Timbratura', roles: ['Operativo', 'Caposquadra'] },
      { key: '/ore', label: 'Ore & Presenze', roles: ['Admin', 'Amministrativo'] },
      { key: '/hr', label: 'Personale (HR)', roles: ['Admin', 'Amministrativo', 'Commerciale', 'CapoGruppo', 'Caposquadra', 'Operativo'] },
      { key: '/assistenza', label: 'Assistenza', roles: ['Admin', 'Amministrativo', 'Caposquadra'] },
      { key: '/squadre-esterne', label: 'Squadre Esterne', roles: ['Admin', 'Amministrativo'] },
      { key: '/team', label: 'Team', roles: ['Admin', 'Operativo', 'Caposquadra', 'Visitatore'] },
    ],
  },
  {
    title: 'Amministrazione',
    features: [
      { key: '/riepilogo-vendite', label: 'Riepilogo Vendite', roles: ['Admin', 'Amministrativo', 'CapoGruppo', 'Visitatore'] },
      { key: '/provvigioni', label: 'Provvigioni', roles: ['Admin', 'Amministrativo', 'Commerciale', 'CapoGruppo'] },
      { key: '/invoices', label: 'Fatture', roles: ['Admin', 'Amministrativo', 'Commerciale', 'Visitatore'] },
      { key: '/redditivita', label: 'Redditività', roles: ['Admin'] },
      { key: '/listino', label: 'Listino', roles: ['Admin'] },
      { key: '/isolamento', label: 'Contratti Isolamento', roles: ['Admin', 'Amministrativo', 'Commerciale', 'CapoGruppo'] },
      { key: '/biblioteca', label: 'Zona File', roles: ['Admin', 'Amministrativo', 'Commerciale', 'CapoGruppo', 'Caposquadra', 'Operativo'] },
    ],
  },
  {
    title: 'Sistema',
    features: [
      { key: '/calendar', label: 'Calendario', roles: ['Admin', 'Commerciale', 'Operativo', 'Caposquadra', 'Amministrativo', 'Visitatore'] },
      { key: '/notifications', label: 'Notifiche', roles: ['Admin', 'Commerciale', 'Operativo', 'Caposquadra', 'Amministrativo'] },
      { key: '/integrations', label: 'Integrazioni', roles: ['Admin', 'Amministrativo'] },
      { key: '/access-log', label: 'Controllo Accessi', roles: ['Admin', 'Amministrativo'] },
    ],
  },
];

export const ALL_FEATURES = FEATURE_GROUPS.flatMap((g) => g.features);

const roleDefaults = (key) => (ALL_FEATURES.find((f) => f.key === key)?.roles) || [];

// Verifica se l'utente può accedere a una funzione (chiave = path).
// Le override dell'Admin hanno priorità sul default del ruolo.
export const hasFeature = (user, key, defaultRoles) => {
  if (!user) return false;
  const ov = user.feature_overrides || {};
  if (Object.prototype.hasOwnProperty.call(ov, key)) return ov[key] === true;
  const roles = defaultRoles || roleDefaults(key);
  return roles.includes(user.ruolo);
};
